function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
var func = PropTypes.func,
    string = PropTypes.string,
    bool = PropTypes.bool;

var OutsideClick = /*#__PURE__*/function (_React$Component) {
  _inherits(OutsideClick, _React$Component);

  var _super = _createSuper(OutsideClick);

  function OutsideClick() {
    var _this;

    _classCallCheck(this, OutsideClick);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (evnt) {
      var node = ReactDOM.findDOMNode(_assertThisInitialized(_this));

      if (node != null) {
        if (!node.contains(evnt.target)) {
          return typeof _this.props.onOutsideClick === "function" ? _this.props.onOutsideClick(evnt) : undefined;
        } else if (node === evnt.target && _this.props.closeOnElementClick) {
          return typeof _this.props.onOutsideClick === "function" ? _this.props.onOutsideClick(evnt) : undefined;
        }
      }
    });

    return _this;
  }

  _createClass(OutsideClick, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this binds to body to avoid getting in a click bubbling fight with React,
      // which binds to document
      return document.body.addEventListener("click", this.handleOutsideClick, {
        capture: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return document.body.removeEventListener("click", this.handleOutsideClick, {
        capture: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var base_props = {
        className: classNames("et--outside-click-area", this.props.className)
      };

      var props = _.extend(base_props, _.omit(this.props, ["element", "className", "onOutsideClick", "closeOnElementClick"]));

      return this.props.element ? this.props.element(props) : /*#__PURE__*/React.createElement("div", props);
    }
  }]);

  return OutsideClick;
}(React.Component);

_defineProperty(OutsideClick, "displayName", "OutsideClick");

_defineProperty(OutsideClick, "propTypes", {
  element: func,
  closeOnElementClick: bool,
  onOutsideClick: func,
  className: string
});

export { OutsideClick as default };